import React from "react";

type Props = {
    items: React.ReactNode[];
    index: number;
    onIndexChange: (i: number) => void;
    className?: string;
};

export default function ReviewSlider({ items, index, onIndexChange, className = "" }: Props) {
    const total = items.length;

    const go = (n: number) => {
        const clamped = Math.max(0, Math.min(n, total - 1));
        onIndexChange(clamped);
    };
    const next = () => go(index + 1);
    const prev = () => go(index - 1);

    // touch swipe
    const startX = React.useRef<number | null>(null);
    const onTouchStart = (e: React.TouchEvent) => (startX.current = e.touches[0].clientX);
    const onTouchEnd = (e: React.TouchEvent) => {
        if (startX.current == null) return;
        const dx = e.changedTouches[0].clientX - startX.current;
        if (dx < -40) next();
        if (dx > 40) prev();
        startX.current = null;
    };

    return (
        <div className={className} aria-roledescription="carousel">
            <div
                className="relative overflow-hidden rounded-2xl bg-white"
                onTouchStart={onTouchStart}
                onTouchEnd={onTouchEnd}>
                <div
                    className="flex transition-transform duration-500 ease-out"
                    style={{ transform: `translateX(-${index * 100}%)` }}>
                    {items.map((item, i) => (
                        <div key={i} className="w-full shrink-0">
                            <div className="p-4 sm:p-5 lg:p-6">{item}</div>
                        </div>
                    ))}
                </div>
                {/* nav */}
            </div>

            {/* dots + status */}
            <div className="mt-2 relative flex items-center justify-center">
                <div className="flex gap-2">
                    {items.map((_, i) => (
                        <button
                            key={i}
                            onClick={() => go(i)}
                            className={`h-2 w-2 rounded-full ${i === index ? "bg-primary-red" : "bg-gray-300"}`}
                            aria-label={`Go to slide ${i + 1}`}
                        />
                    ))}
                </div>
                <div className="absolute right-0 text-xs text-gray-500">
                    Showing {index + 1}–{total}
                </div>
            </div>
        </div>
    );
}
